module.exports = __webpack_public_path__ + "static/media/4 dinner.2abfc69b.png";